"use client";

import { ReactNode } from "react";

type GlowingCardProps = {
    children: ReactNode;
    className?: string;
};

export function GlowingCard({ children, className = "" }: GlowingCardProps) {
    return (
        <div className={`glowing-card-wrapper group ${className}`}>
            <div className="glowing-card-border" />
            <div className="glowing-card-content clay-card">
                {children}
            </div>
        </div>
    );
}
